import { lazy } from "react";
import poshnoshFavicon from "../assets/poshnosh-favicon.png";
import bzFavicon from "../assets/bzQuick-favicon.png";
import dailonFavicon from "../assets/dailon-faviconlogo.png";
import wehkerFavicon from "assets/wehk.svg"
import hailidoFavicon from "assets/hailido.svg"
import homimproveFavicon from "assets/homimprove.svg"
const BzLogo = lazy(() => import("constant/svgLogoComponents").then((module) => ({ default: module.BzLogo, })));
const WehkerLogo = lazy(() => import("constant/svgLogoComponents").then((module) => ({ default: module.WehkerLogo, })));
const HailidoLogo = lazy(() => import("constant/svgLogoComponents").then((module) => ({ default: module.HailidoLogo, })));
const HomimproveLogo = lazy(() => import("constant/svgLogoComponents").then((module) => ({ default: module.HomimproveLogo, })));

export const domainMap = [
  {
    name: "shop.dailon.com.hk",
    title: "明日葉香港｜明日葉哪裡買｜日本製烘焙茶包 - 大輪明日葉",
    description: "明日葉哪裡買？現在香港也買到明日葉！大輪明日葉100%出產自日本八丈島！無論是大輪明日葉焙煎茶包，還是專利生產的大輪明日葉粉末，都能淨化血液，掃走細胞垃圾！",
    favicon: dailonFavicon,
    merchantIds: [84, 15],
    merchantEmail: {
      prod: "dailonjapan@gmail.com",
      dev: "dailonhk@bzquick.com",
    },
    merchantCampaignUid: {
      prod: "Dailonhk%20Web%20Store",
      dev: "Dailonhk%20Web%20Store",
    },
    theme: {
      themeName: "dailonhk",
      companyName: "Dailon hk",
    },
    noDecimalNumber:true,
    noTimeSlots:true
  },
  {
    name: "www.hkposhnosh.com",
    title: "Posh Nosh Upper Class Ingredients",
    description:
      "Posh Nosh cherry-picks the finest ingredients in hopes to bring our beloved “gourmand group” a sense of comfort.",
    favicon: poshnoshFavicon,
    merchantIds: [3],
    merchantEmail: {
      prod: "poshnosh@bzquick.com",
      dev: "pn@bzquick.com",
    },
    merchantCampaignUid: {
      prod: "pnws",
      dev: "Posh%20Nosh%20Demo%20Store",
    },
    theme: {
      themeName: "poshnosh",
      companyName: "Posh Nosh",
    },
    noTimeSlots:true

  },
  {
    name: "artgregator",
    merchantIds: [2],
    theme: {
      themeName: "artgregator",
      companyName: "ARTGREGATOR",
    },
  },
  {
    name: "wehker",
    title: "WE\u2022HKER",
    description:
      "WE\u2022HKER Website",
    Logo: <WehkerLogo style={{ width: "200px", height: "unset" }} title="WEHKER Logo" role="img" />,
    favicon: wehkerFavicon,
    merchantIds: "all",
    theme: {
      themeName: "wehker",
      companyName: "WE\u2022HKER",
    },
  },
  {
    name: "hailido",
    title: "hailido",
    description:
      "hailido Website",
    Logo: <HailidoLogo style={{ width: "200px", height: "unset" }} title="hailido Logo" role="img" />,
    favicon: hailidoFavicon,
    merchantIds: "all",
    theme: {
      themeName: "hailido",
      companyName: "hailido",
    },
  },
  {
    name: "homimprove",
    title: "homimprove",
    description:
      "homimprove Website",
    Logo: <HomimproveLogo style={{ width: "250px", height: "unset" }} title="Homimprove Logo" role="img" />,
    favicon: homimproveFavicon,
    merchantIds: "all",
    theme: {
      themeName: "homimprove",
      companyName: "homimprove",
    },
  },
  {
    name: "default",
    merchantIds: "all",
    title: "Empower Digital Economy",
    description:
      "BzQuick creates solutions that makes your business simple. From now on, you can create invoices and quotes in seconds, get paid fast and track cash flow in one place.",BzLogo,
    Logo: <BzLogo style={{ width: "250px", height: "unset" }} title="BzQuick Logo" role="img" />,
    favicon: bzFavicon,
    theme: {
      themeName: "bzquick",
      companyName: "Bzquick",
    },
  },
  {
    name: "3001",
    merchantIds: "all",
    title: "I am localhost!!!",
    description: "loco man",
    Logo: <BzLogo style={{ width: "250px", height: "unset" }} title="BzQuick Logo" role="img" />,
    favicon: bzFavicon,
    theme: {
      themeName: "bzquick",
      companyName: "develop",
    },
    // noDecimalNumber:true,
    noTimeSlots:true


  },
  {
    name: "bzquick",
    merchantIds: "all",
    title: "Empower Digital Economy",
    description:
      "BzQuick creates solutions that makes your business simple. From now on, you can create invoices and quotes in seconds, get paid fast and track cash flow in one place.",BzLogo,
    Logo: <BzLogo style={{ width: "250px", height: "unset" }} title="BzQuick Logo" role="img" />,
    favicon: bzFavicon,
    theme: {
      themeName: "bzquick",
      companyName: "Bzquick",
    },
  },
];
